import { ConfirmModalService } from './../../shared/confirm-modal/confirm-modal.service';
import { CommonDataSharedService } from 'app/services/commonDataSharedService';
import { CommonRequestResponseService } from './../../../services/common-request-response.service';
import { CommonAuthenticationService } from './../../../services/common-authentication.service';
import { NotificationService } from './../../../services/notification.service';
import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { StudentContactCardComponent } from './student-contact-card/student-contact-card.component';
import { StudentIdentityCardComponent } from './student-identity-card/student-identity-card.component';
import { StudentAcademicCardComponent } from './student-academic-card/student-academic-card.component';

@Component({
  selector: 'app-student-profile',
  templateUrl: './student-profile.component.html',
  styleUrls: ['./student-profile.component.scss'],
})
export class StudentProfileComponent implements OnInit, OnDestroy {

  @ViewChild('identityCard') indentityCard: StudentIdentityCardComponent;
  @ViewChild('contactCard') contactCard: StudentContactCardComponent;
  @ViewChild('academicCard') academicCard: StudentAcademicCardComponent;
  @Input() studentProfileId: number;
  @Input() studentUserId: number;
  @Input() currentStudentPartnerId: number;
  isStudenFirstLogIn: boolean;
  isFirstLogOn: boolean;
  studentProfileLoader = true;
  personalInfoData: any;
  firstFlag = false;
  formSubscriptionArr = [];
  studentProfileUpdate: Subscription;
  avtarUrl: string;

  constructor(
    private notificationService: NotificationService,
    private _commonAuthService: CommonAuthenticationService,
    public _commonRequestResponseService: CommonRequestResponseService,
    public router: Router,
    private commonDataSharedService: CommonDataSharedService,
    private confirmModalService: ConfirmModalService,
    private routes: ActivatedRoute
  ) {
  }

  ngOnInit() {
    this.commonDataSharedService.saveProfile.subscribe(() => {
      if (this.indentityCard.formsTouched || this.indentityCard.imageChange || this.contactCard.formsTouched || this.academicCard.formsTouched) {
        const currentRoute = this.routes.snapshot.url[0].path;
        this.commonDataSharedService.saveModal.next(currentRoute);
        this.commonDataSharedService.duplicateContact.next(true);
      };
    })
    window.scrollTo(0, 0);
    const loginData = this._commonAuthService.getLoginData();
    this.isFirstLogOn = !!loginData.isFirstLogOn;

    if (this.studentUserId) {
      this.getStudentProfileData();
    }
    this.avtarUrl = JSON.parse(localStorage.getItem('loginUserData')).fileUrl;
    /*
    // todo: fix studentProfileDirty
        this.formSubscriptionArr.push(this.commonDataSharedService.studentProfileNavigation.subscribe(() => {
          if (this.formValue && this.formValue.dirty)) {
            this._commonService.setDataWithoutObservable(true, 'studentProfileDirty');
          } else {
            this._commonService.setDataWithoutObservable(false, 'studentProfileDirty');
          }
        }));
    */
    this.studentProfileUpdate = this.commonDataSharedService.studentProfileUpdate.subscribe(() => {
      this.getStudentProfileData();
    });
  }

  getStudentProfileData() {
    const inputJson = {
      studentUserId: this.studentUserId,
      profileId: this.studentProfileId,
      partnerId: this.currentStudentPartnerId
    };
    this.formSubscriptionArr.push(this._commonRequestResponseService.postWithHeader('student/profile/', inputJson, ['profileId'])
      .subscribe(
        (data: any) => {
          this.commonDataSharedService.coachStudentLoginStatus.next(data)
          this.isStudenFirstLogIn = data['isFirstLogOn'];
          if (data && data.personalInformation) {
            this.personalInfoData = data.personalInformation;
            if (this.personalInfoData.address.zipCode !== null && this.personalInfoData.address.zipCode.length === 4) {
              this.personalInfoData.address.zipCode = 0 + this.personalInfoData.address.zipCode;
            }
          }
          this.commonDataSharedService.reloadAutoNotes.next();
          this.firstFlag = true
        },
        () => {
          this.studentProfileLoader = false;
          this.notificationService.show('error', 'Error while fetching data');
        },
        () => {
          this.studentProfileLoader = false;
        }));
  }

  saveData() {
    const module = this._commonAuthService.getModule();
      if (!this.indentityCard || !this.contactCard || !this.academicCard) {
        return;
      }
      if (!(this.indentityCard.identityForm.touched || this.indentityCard.formsTouched || this.contactCard.formsTouched || this.academicCard.academicForm.touched || this.academicCard.formsTouched || this.indentityCard.imageChange)) {
        return;
      }

      const identityData = this.indentityCard.getIdentityData();
      const contactData = this.contactCard.getContactData();
      const academicData = this.academicCard.getAcademicData();

      this.studentProfileLoader = true;

      if (identityData && contactData && academicData) {
        const basicInfoPageOneJson = {
          studentUserId: this.studentUserId,
          firstCall: !!this.isFirstLogOn,
          personalInformation:
          {
            firstName: identityData.value.firstName,
            lastName: identityData.value.lastName,
            middleInitial: identityData.value.miName,
            mailingSameAsResidence: false,
            maritalStatusClassId: '1',
            genderClassId: identityData.value.genderValueId,
            raceClassId: identityData.value.ethnicityId,
            avatarURL: identityData.value.avatarUrlValue ? identityData.value.avatarUrlValue.toString() : null,
            deleteAvatar: identityData.value.deleteAvatar,
            birthDate: identityData.value.userBirthday.toISOString().split('T')[0],
            address: {
              line1: contactData.address && contactData.address.line1 || '',
              line2: contactData.address && contactData.address.line2 || '',
              city: contactData.address && contactData.address.city || '',
              stateClassId: contactData.address && contactData.address.stateClassId || '',
              zipCode: contactData.address && contactData.address.zipCode || '',
              addressClassId: '1'
            },
            efc: identityData.value.efc,
            familySize: identityData.value.familySize,
            gradeClassId: identityData.value.gradeSchoolId,
            graduationMonth: identityData.value.userMonthDate,
            graduationYear: identityData.value.userYearDate,
            communications: contactData.communications,
            citizenship: {
              usCitizenId: identityData.value.usCitizenValue,
              permanentResident: identityData.value.permanentResidentValue
            },
            gpa: {
              weighted: academicData.value.gpaWeighted || null,
              unweighted: academicData.value.gpaUnweighted || null,
              unknown: false
            },
            studies: academicData.value.studies,
            courseValue: academicData.value.advancedClassTaken,
            scores: {
              sat: {
                ebrw: academicData.value.satComposite !== +academicData.value.satComposite ? null : +academicData.value.satComposite,
                math: 0
              },
              actComposite: academicData.value.actComposite !== +academicData.value.actComposite ? null : +academicData.value.actComposite
            },
            preferredclassSizeClassIds: academicData.value.preferredClassSizeId
          }
        };
        localStorage.setItem('genderIdValue', JSON.stringify(identityData.value.genderValueId));
        this.commonDataSharedService.studentMenu.next({ student: false });
        this.formSubscriptionArr.push(this._commonRequestResponseService.postWithHeader('student/questionnaire', basicInfoPageOneJson)
          .subscribe(
            (data: any) => {
              this.studentProfileLoader = false;
              this.updateUserProfileMainNav(data.firstName, data.lastName, data.url, data.classYearDescription);
              this.commonDataSharedService.studentMenu.next({ student: true });
              this.commonDataSharedService.updateCoachStudentDetail.next();
              this.commonDataSharedService.showLoader.next(false);
              setTimeout(() => {
                this.notificationService.show('success', 'Profile saved Successfully');
              }, 10)
              this.firstFlag = false;
            }, () => {
              this.studentProfileLoader = false;
              this.notificationService.show('error', 'Error while saving profile');
              this.commonDataSharedService.studentMenu.next({ student: true });
            }));
      }

  }

  updateUserProfileMainNav(firstName, lastName, fileUrl, classYearDescription) {
    const updateProfileObj = {
      firstName: firstName,
      lastName: lastName,
      fileUrl: fileUrl || this.avtarUrl
    };

    const loginData = this._commonAuthService.getLoginData();

    if (loginData.module.toLowerCase() === 'student') {
      loginData.firstName = firstName;
      loginData.lastName = lastName;
      loginData.fileUrl = fileUrl || this.avtarUrl;
      loginData.classYearDescription = classYearDescription;
      this._commonAuthService.setLoginData(loginData);
      this.commonDataSharedService.updateProfile.next(updateProfileObj);
    }
  }

  ngOnDestroy(): void {
    const module = this._commonAuthService.getModule();
    this.studentProfileUpdate.unsubscribe();
  }

}
